import { CircularProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';

const styles = makeStyles(theme => ({
  button: {
    position: 'relative',
    margin: 0,
    '& > span:last-of-type:not(:only-child)': {
      display: 'none',
    },
    minWidth: 110,
  },
  buttonHidden: {
    padding: 0,
  },
  loading: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    marginTop: theme.spacing(1),
  },
}));

export default function (props: any) {
  const classes = styles();
  const { loading } = props;

  return (
    <Button
      className={classNames(
        classes.button,
        loading ? classes.buttonHidden : '',
      )}
      variant="contained"
      {...props}
    >
      {loading ? (
        <CircularProgress size={30} className={classes.loading} />
      ) : (
          props.children
        )}
    </Button>
  );
}
